var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dc4c2c",
    d: "M8,24c0,9.941,8.059,18,18,18s18-8.059,18-18H26H8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7a278",
    d: "M26,6v18h18C44,14.059,35.941,6,26,6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c06346",
    d: "M26,6C16.059,6,8,14.059,8,24h18V6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9b341f",
    d: "M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.673,19.012H10v10h2.024v-3.521H14.3c1.876,0,3.397-1.521,3.397-3.397v-0.058 C17.697,20.366,16.343,19.012,14.673,19.012z M15.57,22.358c0,0.859-0.697,1.556-1.556,1.556h-1.99v-3.325h1.99 c0.859,0,1.556,0.697,1.556,1.556V22.358z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.e35aa10a1f6f416437fa881d044b7b03.svg";
export { ForwardRef as ReactComponent };